export const venuesData = [
  {
    id: 2,
    text: "category",
    submenu: {
      "": [
        {
          id: 1,
          name: "Indoor Restaurant",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 2,
          name: "Outdoor Restaurant",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 3,
          name: "Rooftop Weddings",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 4,
          name: "Poolside Wedding",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 5,
          name: "Beach Weddings",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 6,
          name: "Garden Weddings",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 7,
          name: "Boats And Yachts",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 8,
          name: "Country Club",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 9,
          name: "Ballroom Weddings",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 10,
          name: "Outdoor Weddings",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 11,
          name: "Desert Weddings",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
        {
          id: 12,
          name: "Terrace",
          created_at: "2024-03-05T15:26:10.000000Z",
          updated_at: "2024-03-05T15:26:10.000000Z",
        },
      ],
    },
  },
];
